import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
const spacingDefaults = {
    left: 0, right: 0, top: 0, bottom: 0,
};
const LayoutWrapper = ({ layout, children }) => {
    // if no layout defined just return without wrapper
    if (!layout) {
        return children;
    }
    const padding = layout.padding || spacingDefaults;
    const margin = layout.margin || spacingDefaults;
    return (_jsx(Box, { sx: {
            paddingLeft: `${padding.left || 0}px`,
            paddingRight: `${padding.right || 0}px`,
            paddingTop: `${padding.top || 0}px`,
            paddingBottom: `${padding.bottom || 0}px`,
            marginLeft: `${margin.left || 0}px`,
            marginRight: `${margin.right || 0}px`,
            marginTop: `${margin.top || 0}px`,
            marginBottom: `${margin.bottom || 0}px`,
            backgroundColor: (layout && layout.backgroundColor) || 'inherit',
        }, children: children }));
};
export default LayoutWrapper;
//# sourceMappingURL=LayoutWrapper.js.map